<div class="cards-container">
  <div class="container">
    <div class="row cards text-center content-wrapper">
      <div class="col-lg-5 col-12 mb-5 mb-lg-0">
        <div class="new-style-header d-flex">
          <div class="w-50">
            <span class="font-29 uppercase font-weight-bold d-block" style="height: 16px;">{{'connect' | translate}}</span>
            <br>
            <span class="font-21 uppercase font-weight-bold" style="padding-right: 2px">{{'easy' | translate}}</span>
          </div>
          <div class="w-50" style="display: flex; flex-wrap: wrap; align-items: center; justify-content: flex-start;">
            <span class="colo-red font-weight-bold uppercase pl-2 special-for-300-doctors">{{'300-doctor' | translate}}</span>
          </div>
        </div>
        <div class="new-style-content__icons">
          <img alt="" loading="lazy" src="assets/landing/about-us/home.png"
               style="height: 120px; border-radius: 24px; background-color: #db193a">

          <img alt="" loading="lazy" src="assets/landing/about-us/phone.png"
               style="height: 120px; border-radius: 24px; background-color: #93d0e1">

          <img alt="" loading="lazy" src="assets/landing/about-us/video.png"
               style="height: 120px; border-radius: 24px; background-color: #f6a3ae">
        </div>
      </div>
      <!-- <div class="col-lg-3 col-12 mb-5 mb-lg-0">
        <div class="new-style-header d-flex uppercase font-weight-bold"
             style="flex-direction: column; justify-content: center">
          <span class="font-32" style="height: 34px">{{'call-out' | translate}}</span>
          <div class="font-20">
            <span class="colo-red">{{'Medicines' | translate}} </span>
            <span>{{'at-home' | translate}}</span>
          </div>
        </div>
        <div
            style="display: flex; justify-content: center; height: 220px; align-items: center; background-color: white; padding: 25px; border-radius: 50px; box-shadow: 0 0 12px 7px #8d8d8d3d;">
          <div
              style="display: flex; align-items: center; border-radius: 16px; justify-content: center; width: 100px; height: 120px;background-color: #db193a">
            <img alt="" loading="lazy" src="assets/landing/about-us/home_plus.png"
                 style="height: 120px; border-radius: 24px; background-color: #db193a">
          </div>
        </div>
      </div> -->
      <div class="col-lg-3 col-12 mb-5 mb-lg-0">
        <div class="new-style-header d-flex uppercase font-weight-bold"
             style="flex-direction: column; justify-content: center">
          <span class="font-22" style="height: 24px"><span class="colo-red">20</span> {{'medical' | translate}}</span>
          <span class="font-23">{{'about-specialties' | translate}}</span>
        </div>
        <div [queryParams]="{serviceType: 1, specId: 9}" routerLink="/search"
             style="cursor:pointer; display: flex; justify-content: center; height: 220px; align-items: center; background-color: white; border-radius: 50px; box-shadow: 0 0 12px 7px #8d8d8d3d;">
          <div
              style="display: flex; align-items: center; border-radius: 16px; justify-content: center; height: 120px;">
            <div class="uppercase font-weight-bold" style="display: flex; flex-direction: column;">
              <span class="text-white p-2 mb-1"
                    style="background-color: #ce0935; border-radius: 20px">{{'find-doctor' | translate}}</span>
              <span>{{'easily' | translate}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container pt-5">
  <!-- <img loading="lazy" src="/assets/photos/about.jpg" alt="" class="w-100"> -->
  <h2 class="uppercase font-26 mb-4">{{'about-us' | translate}}</h2>
  <p class="font-14">
    {{'redmed-is-the-first-medical-services-platform-in-georgia-that-is-easily-connecting-you-with-the-doctor-you-want,-at-a-time-and-place-convenient-for-you.-the-platform-unites-up-to-300-doctors-of-more-than-20-specialties-from-georgia,-germany,-the-united-states-of-america,-and-austria.-we-cooperate-with-insurance-companies-and-issue-necessary-documentation-for-insurance.' | translate}}
  </p>
  <p class="font-14">{{'redmed-is-making-it-easier-for-you-to-take-care-of-your-health-and-that-of-your-family-members.' | translate}}</p>
  <h2 class="uppercase font-26 mb-4 mt-5">{{'by-redmed' | translate}}</h2>
  <ul class="font-14 mb-5">
    <li>
      <a href="https://redmed.page.link/search-video-call" target="_blank">{{"get-a-doctor's-video-or-phone-consultation" | translate}}</a>
    </li>
    <li>
      <a href="https://redmed.page.link/clinic" target="_blank">{{'book-a-visit-to-the-clinic' | translate}}</a>
    </li>
    <!-- <li>
      <a href="https://redmed.page.link/pharmacy" target="_blank">{{'call-the-pharmacy-at-home' | translate}}</a>
    </li> -->
    <li>
      <a href="https://redmed.page.link/search-home-visit" target="_blank">{{'call-the-doctor-at-home' | translate}}</a>
    </li>
    <li>
      <a href="https://redmed.page.link/laboratory" target="_blank">{{'call-the-lab-at-home' | translate}}</a>
    </li>
    <!-- <li>
      <a href="https://redmed.page.link/covid-clinic" target="_blank">{{'take-advantage-of-the-services-of-the-covid-19-clinic' | translate}}</a>
    </li> -->

    <!--    <li>-->
    <!--      <a href="https://redmed.page.link/pediatry-clinic" target="_blank">ისარგებლე პედიატრიული კლინიკა 24/7-ზე მომსახურებით</a>-->
    <!--    </li>-->
    <!--    <li>-->
    <!--      <a href="https://redmed.page.link/echoscopy" target="_blank">გამოიძახე ინსტრუმენტული კვლევა სახლში</a>-->
    <!--    </li>-->
    <!--    <li>-->
    <!--      <a href="https://redmed.page.link/laboratory" target="_blank">გამოიძახე ლაბორატორიული კვლევა სახლში</a>-->
    <!--    </li>-->

  </ul>
  <h2 class="uppercase font-26 mb-4">{{'types-of-services' | translate}}</h2>
  <p class="mb-5 font-14">
    <span class="font-weight-bold d-block uppercase font-16 mb-2">
      <a href="https://redmed.page.link/search-video-call" target="_blank">{{'video-and-telephone-consultation' | translate}}</a>
    </span>
    {{'save-time,-avoid-queues-and-traffic-jams-at-the-clinic-and-get-video-or-audio--consultation-with-a-redmed-doctor-at-a-time-and-place-convenient-for-you.-with-redmed,-you-can-send-the-results-of-laboratory-and-instrumental-studies-to-the-doctor-before-or-during-the-consultation.-the-doctor-will-also-send-you-the-necessary-documentation-for-prescription-and-insurance-on-the-redmed-portal.-with-redmed,-you-can-talk-to-the-doctor-repeatedly-with-the-help-of-chat-within-1-week-after-the-consultation.' | translate}}
    <br><br>

    <span class="font-weight-bold d-block uppercase font-16 mb-2">
      <a href="https://redmed.page.link/clinic" target="_blank">{{'book-a-visit' | translate}}</a>
    </span>
    {{"with-redmed,-it-is-possible-to-register-at-the-clinic-at-the-desired-time-and-avoid-standing-in-line-and-boring-waiting-at-the-doctor's-office.-easily---search-for-the-desired-clinic,-doctor-and-choose-a-convenient-time.-so-visiting-the-clinic-is-more-comfortable." | translate}}
    <br><br>

    <span class="font-weight-bold d-block uppercase font-16 mb-2">
      <a href="https://redmed.page.link/laboratory" target="_blank">{{'call-the-lab-at-home' | translate}}</a>
    </span>
    {{"up-to-900-laboratoy-tests-can-be-conducted-in-redmed's-partner-laboratories.-გამოძახება?-the-desired-analyzes-and-laboratory-without-leaving-home-or-book-a-visit-to-the-laboratory-with-the-help-of-the-application-or-the-website." | translate}}
    <br><br>

    <!-- <span class="font-weight-bold d-block uppercase font-16 mb-2">
      <a href="https://redmed.page.link/pharmacy" target="_blank">{{'call-the-pharmacy-at-home' | translate}}</a>
    </span>
    {{"redmed-takes-care-of-simplifying-your-everyday-life.-place-an-order-for-pharmacy-products-with-the-application-and-the-courier-will-shortly-deliver-your-purchase-to-you-at-the-desired-time-and-place.-our-exclusive-partner-is-psp-pharmacy-chain." | translate}}
    <br><br> -->

    <span class="font-weight-bold d-block uppercase font-16 mb-2">
      <a href="https://redmed.page.link/search-home-visit" target="_blank">{{'doctor-at-home' | translate}}</a>
    </span>
    {{"with-redmed,-it-is-possible-to-call-a-specialist-of-the-desired-direction-at-home.-the-doctor-will-send-you-the-documents-required-for-insurance-on-the-redmed-portal-and-application.-in-case-of-additional-questions,-you-can-contact-the-doctor-with-the-help-of-the-application-within-7-days-of-the-visit." | translate}}
    <br><br>
<!-- 
    <span class="font-weight-bold d-block uppercase font-16 mb-2">
      <a href="https://redmed.page.link/covid-clinic" target="_blank">{{'24/7-online-covid-19-clinic' | translate}}</a>
    </span>
    {{"family-doctors-specially-trained-in-the-management-of-covid-19-infection-will-answer-all-questions.-if-the-infection-is-confirmed,-the-doctor-will-assess-the-condition-through-a-video-consultation-and-give-you-a-recommendation-about-the-treatment,-place-and-methods.-if-you-decide-to-be-treated-at-home,-you-will-be-monitored-until-you-fully-recover." | translate}}
    <br><br>
    {{"the-family-doctors-at-the-covid-19-clinic-will-also-help-you-assess-and-manage-post-covid-symptoms." | translate}}
    <br><br> -->

    <span class="font-weight-bold d-block uppercase font-16 mb-2">
      <a href="https://redmed.ge/search?serviceType=1&foreign=true" target="_blank">{{'doctors-abroad' | translate}}</a>
    </span>
    {{"redmed-gives-you-a-unique-opportunity-to-have-a-video-consultation-with-georgian-doctors-working-abroad.-doctors-working-in-america,-germany-and-austria-have-many-years-of-work-experience-in-various-fields,-such-as:-gynecology,-radiology,-urology,-neurology,-infectious-diseases,-geriatrics,-children's-oncohematology-and-neurology.-contact-the-doctor-with-the-redmed-application-without-leaving-your-home-or-country.-you-will-also-receive-the-necessary-documentation-for-insurance-with-redmed." | translate}}
    <br><br>
    <!--    <span class="font-weight-bold d-block uppercase font-16 mb-2">-->
    <!--      <a href="https://redmed.page.link/search-home-visit" target="_blank">ექიმი სახლში</a>-->
    <!--    </span>-->
    <!--    REDMED-ით შესაძლებელია სასურველი მიმართულების სპეციალისტის სახლში გამოძახება. დაზღვევისთვის საჭირო დოკუმენტაციას-->
    <!--    ექიმი REDMED-ის პორტალზე გამოგიგზავნის. დამატებითი კითხვების შემთხვევაში, ვიზიტიდან 7 დღის განმავლობაში შეგიძლია-->
    <!--    ექიმს აპლიკაციის დახმარებით დაუკავშირდე.-->
    <!--    <br><br>-->
    <!--    <span class="font-weight-bold d-block uppercase font-16 mb-2">-->
    <!--      <a href="https://redmed.page.link/pediatry-clinic" target="_blank">პედიატრიული კლინიკა 24/7-ზე</a>-->
    <!--    </span>-->
    <!--    REDMED-ის პედიატრიული კლინიკა 24/7-ზე დაკომპლექტებულია კვალიციური პედიატრებით, რომელთაც შეგიძლია შენი შვილების-->
    <!--    ჯანმრთელობაზე ზრუნვა მიანდო. გაიარე სასურველ პედიატრთან ვიდეო კონსულტაცია ნებისმიერ დროს, ნებისმიერი ადგილიდან.-->
    <!--    კონსულტაციიდან ერთი კვირის განმავლობაში განმეორებით დაუკავშირდი ექიმს დამატებითი ხარჯების გარეშე.-->
    <!--    <br><br>-->
    <!--    <span class="font-weight-bold d-block uppercase font-16 mb-2">-->
    <!--      <a href="https://redmed.page.link/covid-clinic" target="_blank">COVID-19 ონლაინ კლინიკა 24/7-ზე</a>-->
    <!--    </span>-->
    <!--    COVID-19 ინფექციის მართვაზე Სპეციალურად გადამზადებული ოჯახის ექიმები გასცემენ პასუხს Covid-19 -ის შესახებ ყველა-->
    <!--    კითხვაზე. ინფექციის დადასტურების შემთხვევაში, ექიმი ვიდეოკონსულტაციის საშუალებით შეაფასებს მდგომარეობას და მოგცემს-->
    <!--    რეკომენდაციას მკურნალობის ადგილისა და მეთოდების შესახებ. ბინაზე მკურნალობის გადაწყვეტილების შემთხვევაში კი შენს-->
    <!--    გამოჯანმრთელებამდე გაგიწევს მეთვალყურეობას.-->
    <!--    <br>-->
    <!--    COVID-19 კლინიკის ოჯახის ექიმები ასევე დაგეხმარებიან კოვიდის შემდგომი სიმპტომების შეფასებაში და მართვაში.-->
    <!--    <br><br>-->
    <!--    <span class="font-weight-bold d-block uppercase font-16 mb-2">-->
    <!--      <a href="https://redmed.ge/search?serviceType=1&foreign=true"-->
    <!--         target="_blank">ექიმები საზღვარგარეთ</a>-->
    <!--    </span>-->
    <!--    REDMED-ი გაძლევს უნიკალურ შესაძლებლობას გაიარო ვიდეოკონსულტაცია საზღვარგარეთ მოღვაწე ქართველ ექიმებთან. ამერიკაში,-->
    <!--    გერმანიასა და ავსტრიაში მოღვაწე ექიმებს აქვთ მრავალწლიანი სამუშაო გამოცდილება სხვადასხვა დარგში, როგორიცაა:-->
    <!--    გინეკოლოგია, რადიოლოგია, უროლოგია, ნევროლოგია, ინფექციური დაავადებები, გერიატრია, ბავშვთა ონკოჰემატოლოგია და-->
    <!--    ნევროლოგია. დაუკავშირდი ექიმს REDMED-ის აპლიკაციით სახლიდან და ქვეყნიდან გაუსვლელად. დანიშნულებისა და დაზღვევისთვის-->
    <!--    საჭირო დოკუმენტაციასაც REDMED-ის პორტალზე მიიღებ.-->
    <!--    <br><br>-->
    <!--    <span class="font-weight-bold d-block uppercase font-16 mb-2">-->
    <!--      <a href="https://redmed.page.link/pharmacy" target="_blank">გამოიძახე აფთიაქი სახლში</a>-->
    <!--    </span>-->
    <!--    REDMED-ი ზრუნავს შენი ყოველდღიურობის გამარტივებაზე. განათავსე სააფთიაქო პროდუქტებზე შეკვეთა აპლიკაციით და კურიერი-->
    <!--    ოპერატიულად მოგიტანს შენს შენაძენს სასურველ დროსა და ადგილას. Ჩვენი ექსკლუზიური პარტნიორია პსპ-ს სააფთიაქო ქსელი.-->
    <!--    <br><br>-->
  </p>
</div>